import { MDBBtn, MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getUserNumberList } from "../../../apiclients/streamsapi_bridge";
import AddUserAndExternal from "../../../views/popups/hunt/AddUserAndExternal";
import PopupLoader from "../../../views/popups/PopupLoader";
import arrow from "../../images/arrow_ic.svg";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function HGSequentialGroup({
  seqGroups,
  register,
  setValue,
  errors,
  getValues,
  control,
  setError,
  reset,
  groupcode,
  watch,
  clearErrors,
  setemptySequenceIndex,
  emptySequenceIndex,
  setEMessage,
  emessage,
  userPhoneDetails,
}) {
  const { t, i18n } = useTranslation();

  const [defaultFieldValues, setDefaultFieldValues] = useState();
  // const [defaultFlag, setDefaultFlag] = useState(true);

  const {
    fields: groupseqFields,
    append: groupSeqAppend,
    remove: groupSeqRemove,
  } = useFieldArray({
    name: "sequenceGroup",
    control,
  });
  const errorRef = useRef(null);
  useEffect(() => {
    if (emessage && errorRef.current) {
      errorRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      errorRef.current.focus();
    }
  }, [emessage]);
  

  useEffect(() => {
    const formatData = seqGroups.reduce(
      (prev, groups) => {
        const sequenceIndex = groups.seq_num;
        const userPhoneData = {
          user_num_id: groups.id,
          member: groups.member,
          title: groups.title,
          extnum_user_id: groups.extnum_user_id,
          extension_number: groups.extension ? groups.extension : formattedNumber(groups.member),
        };
        if (!prev.sequenceGroup[sequenceIndex]) {
          prev.sequenceGroup[sequenceIndex] = {
            ring_secs: groups.ring_secs,
            seq: `seq${groups.seq_num}`,
            oldseq: `seq${groups.seq_num}`,
            userphone: [userPhoneData],
          };
        } else {
          prev.sequenceGroup[sequenceIndex].userphone.push(userPhoneData);
        }
        return prev;
      },
      { sequenceGroup: [] }
    );

    formatData.sequenceGroup = formatData.sequenceGroup.filter(
      (group) => group !== null
    );

    console.log(
      "group seqiuence  ::::::: " + JSON.stringify(formatData.sequenceGroup)
    );
    reset((prev) => ({ ...prev, sequenceGroup: formatData.sequenceGroup }));
  }, [seqGroups]);

  const handleAddSequence = () => {
    groupSeqAppend({
      ring_secs: 20,
      seq: `seq${groupseqFields.length}`,
      oldseq: "",
      userphone: [],
    });
  };

  const removeSeq = (index, seqObj) => {
    groupSeqRemove(index);
    if (seqObj.oldseq !== "") {
      let deletedSeq = getValues("delete_Seq") ?? [];
      const seqid =
        seqObj.oldseq && seqObj.oldseq != ""
          ? parseInt(seqObj.oldseq.slice(-1))
          : parseInt(seqObj.seq.slice(-1));
      deletedSeq.push(seqid);
      setValue("delete_Seq", deletedSeq, { shouldDirty: true });
       for (let i = index; i < (groupseqFields.length) - 1; i++) {
          setValue(`sequenceGroup.${i}.seq`, `seq${(i)}`, { shouldDirty: true });
        }
    }
  };

  return (
    <>
      <div className="add-numbermain align-items-start">
        <div className="general-settings">{t("SequentialGroups")}</div>
        <MDBBtn
          className="btn btn-primary green-button display-inline float-right me-2"
          disabled={groupseqFields.length === 4}
          onClick={handleAddSequence}
        >
          <MDBIcon fas icon="plus" size="sm" /> {t("Addsequence")}
        </MDBBtn>
      </div>

      {emessage && (
        <span tabIndex="-1" ref={errorRef} className="alert-msgnonc text-danger">{emessage}</span>
      )}

      <div className="d-flex mt-2 flex-column-sm ip-routing-plan ip-align-items-baseline ip-align-center overflow-x-auto py-3">
        {groupseqFields &&
          groupseqFields.length > 0 &&
          groupseqFields.map((seqField, seqIndex) => (
            <>
              <div
                className={`sequence ${emptySequenceIndex.includes(seqIndex + 1) ? "border-danger" : ""}`}
                key={seqField.id}
              >
                <UserNumber
                  seqIndex={seqIndex}
                  register={register}
                  control={control}
                  setValue={setValue}
                  groupcode={groupcode}
                  seqField={seqField}
                  removeSeq={removeSeq}
                  getValues={getValues}
                  watch={watch}
                  errors={errors}
                  clearErrors={clearErrors}
                  setemptySequenceIndex={setemptySequenceIndex}
                  emptySequenceIndex={emptySequenceIndex}
                  setEMessage={setEMessage}
                  userPhoneDetails={userPhoneDetails}
                />
              </div>

              {seqIndex !== groupseqFields.length - 1 && (
                <div>
                  <img src={arrow} className="w_100px ip-rorate-90 py-15" />
                </div>
              )}
            </>
          ))}
      </div>
      {/* <div className="text-danger mt-2">
        <strong className="text-danger">Error: </strong>Every sequence should
        have a user/number.
      </div>
      <div className="text-danger mt-2">
        <strong className="text-danger">Error: </strong>Ringtime should not
        exceed 500 Seconds.
      </div> */}

      <div className="routing-border"></div>
    </>
  );
}
export default HGSequentialGroup;

const UserNumber = ({
  seqIndex,
  register,
  control,
  setValue,
  groupcode,
  seqField,
  removeSeq,
  getValues,
  watch,
  errors,
  clearErrors,
  setemptySequenceIndex,
  emptySequenceIndex,
  setEMessage,
  userPhoneDetails,
}) => {
  const navigate = useNavigate();
  const {
    fields: userNumFields,
    append: userNumAppend,
    remove: userNumRemove,
  } = useFieldArray({
    name: `sequenceGroup.${seqIndex}.userphone`,
    control,
  });
  const { t, i18n } = useTranslation();
  const [addUserPhnum, setaddUserPhnum] = useState(false);
  const toggleShow16 = () => setaddUserPhnum(!addUserPhnum);
  const [isloading, setIsLoading] = useState(false);
  const [userNumList, setUserNumList] = useState([]);
  const [existingUserNum, setExistingUserNum] = useState([]);
  const [addUserNumDetails, setAddUserNumDetails] = useState({});
  const [unSaveUserNumber, setunSaveUserNumber] = useState([]);
  const addUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addUserRef.current.click();
  }

  async function HandleAddNumber(index, userNumbers) {
    try {
      setIsLoading(true);
      let updateEmptyseqList = [...emptySequenceIndex];
      updateEmptyseqList.splice(emptySequenceIndex.indexOf(index + 1), 1);
      setemptySequenceIndex(updateEmptyseqList);
      if (updateEmptyseqList.length === 0) {
        setEMessage("");
      }
      // setIsLoading(true);
      // console.log("userPhoneDetails ::::::::::::::::::::::::::::: "+JSON.stringify(userPhoneDetails));
      // const response = await getUserNumberList(
      //   JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      //   groupcode
      // );
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 1000);
      // if (!response.json) {
      //   const message = `An error has occured: ${response.statusText}`;
      //   return;
      // }
      // let rawData = await response.json();
      // if (!rawData) {
      //   window.alert(`info with id  not found`);
      //   navigate("/");
      // }
      // Not using above route as we are getting it directly from member list at the time of page load
      let userNumberLists = userPhoneDetails.length > 0 ? userPhoneDetails : [];
      userNumberLists = userNumberLists.map((iserPhone) => ({
        title: iserPhone.name,
        member: iserPhone.uniqueid,
        extnum_user_id: 0,
        ...(iserPhone.extension && { extension: iserPhone.extension }),
      }));
      console.log(
        "userNumberLists :::::::: " + JSON.stringify(userNumberLists)
      );
      if (userNumbers.oldseq !== "") {
        const existMember = userNumbers.userphone.map((user) => user.member);
        userNumberLists = userNumberLists.filter(
          (userNumber) => !existMember.includes(userNumber.member)
        );
      }
      setUserNumList(userNumberLists);
      setExistingUserNum(userNumbers.userphone ?? []);

      setAddUserNumDetails({
        userNumList: userNumberLists,
        existingUserNum: userNumbers.userphone ?? [],
      });
      setTimeout(() => {
        setIsLoading(false);
      }, 500);

      toggleShow16();
    } catch (e) {
      console.log(`Unable to load the sepcific group info:${e}`);
    }
  }

  const addExtNum = (objArray) => {
    if (objArray && objArray.length > 0) {
      objArray.map((item) => {
        userNumAppend(item);
      });
    }
  };

  return (
    <>
      <div className="sequenceheader w-100">
        <span className="d-flex align-items-center justify-content-between">
          <label className="fw-bold fs-5">
            {t("sequence")} {seqIndex + 1}
          </label>
        </span>
        <div className="d-flex align-items-center">
          <MDBBtn
            size="sm"
            className="buttonsize mx-2"
            onClick={(e) => HandleAddNumber(seqIndex, seqField)}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t("AdduserNumber")}
          </MDBBtn>
          <MDBIcon
            className="mx-2 fs-5"
            icon="close text-primary "
            onClick={(e) => removeSeq(seqIndex, seqField)}
          />
        </div>
      </div>
      <div className="ringtime ">
        <label>{t("RingTime")}</label>
        <div className="d-flex">
          <div className="phoneselect">
            <input
              type="text"
              value={watch(`sequenceGroup.${seqIndex}.ring_secs`)}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              className=" "
              onChange={(e) => {
                clearErrors(`sequenceGroup.${seqIndex}.ring_secs`);
                setValue(
                  `sequenceGroup.${seqIndex}.ring_secs`,
                  e.target.value,
                  { shouldDirty: true }
                );
                setValue(`sequenceGroup.${seqIndex}.isEdited`, true, {
                  shouldDirty: true,
                });
              }}
            />
            <span className="seconds">{t("seconds")}</span>
            {errors?.sequenceGroup?.[seqIndex]?.ring_secs && (
              <p className="text-danger">
                {errors.sequenceGroup?.[seqIndex].ring_secs.message}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="sequence-body m-2">
        {/* {alert(JSON.stringify(userNumFields))} */}
        {userNumFields &&
          userNumFields.length > 0 &&
          userNumFields.map((userNum, userNumIndex) => (
            <>
              <div className="add-numbermain" key={userNum.id}>
                <strong>{userNum.title}</strong>
                <div className="d-flex align-items-center">
                  <span>{userNum.extension_number}</span>
                  <MDBIcon
                    className="ms-4 fs-5"
                    onClick={(e) => {
                      let deleteid = userNum.user_num_id;

                      if (deleteid != "") {
                        let deletedids = getValues("delete_user_num_id") ?? [];
                        deletedids.push(deleteid + "_" + seqIndex);
                        setValue("delete_user_num_id", deletedids, {
                          shouldDirty: true,
                        });
                      }
                      if (userNumFields.length === 1) {
                        userNumRemove(userNumIndex);
                        removeSeq(seqIndex, seqField);
                      } else {
                        userNumRemove(userNumIndex);
                      }
                      const updateUnSave = unSaveUserNumber.filter(
                        (unsave) => unsave.member !== userNum.member
                      );
                      setunSaveUserNumber(updateUnSave);
                    }}
                    icon="close text-primary "
                  />
                </div>
              </div>
              {userNumIndex !== userNumFields.length - 1 && (
                <div className="routing-border pt-2 m-0"></div>
              )}
            </>
          ))}
      </div>
      {addUserPhnum && (
        <PopupLoaderNew
          title={t("AdduserNumbertoseq")}
          content={
            <AddUserAndExternal
              onClose={toggleShow16}
              addUserNumDetails={addUserNumDetails}
              addExtNum={addExtNum}
              unSaveUserNumber={unSaveUserNumber}
              setunSaveUserNumber={setunSaveUserNumber}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setaddUserPhnum}
          onClose={toggleShow16}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
};
